import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

graphql(`
  fragment ReceiptFields on Receipt {
    id
    type
    amount_inc_tax
    amount_tax
    claimable_percentage
    claimable_amount_inc_tax
    claimable_converted_amount_inc_tax
    converted_currency
    exchange_rate
    currency
    description
    date
    image {
      ...MediaFields
    }
  }
`);

export const receiptQuery = graphql(`
  query Receipt($id: ID!) {
    receipt(id: $id) {
      ...ReceiptFields
    }
  }
`);

export type RefundRecord = NonNullable<
  ResultOf<typeof refundsQuery>["refunds"]
>[number];

export const refundsQuery = graphql(`
  query Refunds($object_type: ModelType!, $object_id: ID!) {
    refunds(object_type: $object_type, object_id: $object_id) {
      id
      uuid
      type
      permalink
      maximum_refund_amount
      refund_amount
      currency
      status
      bank_name
      bank_account_name
      bank_account_number
      bank_identifier_code
      bank_country
      recipient_address
      supplierPayments {
        id
        amount
        currency
        status
        tax_type
        due_date
        description
        created_at
      }
      receipts {
        ...ReceiptFields
      }
      payments {
        id
        method
        amount
        currency
        refunded_at
        transaction_number
      }
    }
  }
`);

export const updateRefundMutation = graphql(`
  mutation UpdateRefund($id: ID!, $input: UpdateRefundInput!) {
    updateRefund(id: $id, input: $input) {
      id
      type
      maximum_refund_amount
      refund_amount
      currency
      status
      bank_name
      bank_account_name
      bank_account_number
      bank_identifier_code
      bank_country
      recipient_address
    }
  }
`);

export const closeRefundMutation = graphql(`
  mutation CloseRefund($id: ID!) {
    closeRefund(id: $id) {
      id
      status
    }
  }
`);

export const resendRefundEmailMutation = graphql(`
  mutation ResendRefundEmail($id: ID!) {
    resendRefundEmail(id: $id) {
      id
    }
  }
`);

export const createRefundMutation = graphql(`
  mutation CreateRefund(
    $object: ConnectMorphToInput!
    $type: RefundType!
    $input: UpdateRefundInput
  ) {
    createRefund(object: $object, type: $type, input: $input) {
      id
      type
      maximum_refund_amount
      refund_amount
      currency
      status
      bank_name
      bank_account_name
      bank_account_number
      bank_identifier_code
      bank_country
      recipient_address
    }
  }
`);

export const createRefundPaymentMutation = graphql(`
  mutation CreateRefundPayment($input: CreateRefundPaymentInput!) {
    createRefundPayment(input: $input) {
      id
      method
      amount
      currency
      refunded_at
      transaction_number
    }
  }
`);

export const updateRefundPaymentMutation = graphql(`
  mutation UpdateRefundPayment($id: ID!, $input: UpdateRefundPaymentInput!) {
    updateRefundPayment(id: $id, input: $input) {
      id
    }
  }
`);

export const deleteRefundPaymentMutation = graphql(`
  mutation DeleteRefundPayment($id: ID!) {
    deleteRefundPayment(id: $id) {
      id
    }
  }
`);

export const analyzeReceiptImageMutation = graphql(`
  mutation AnalyzeReceiptImage($filePath: String!) {
    analyzeReceiptImage(filePath: $filePath) {
      amount_inc_tax
      amount_tax
      currency
      date
      type
      description
      filePath
      imageUrl
    }
  }
`);

export const createReceiptMutation = graphql(`
  mutation CreateReceipt($input: CreateReceiptInput!) {
    createReceipt(input: $input) {
      id
      type
      amount_inc_tax
      amount_tax
      currency
      description
      date
      image {
        ...MediaFields
      }
    }
  }
`);

export const deleteReceiptMutation = graphql(`
  mutation DeleteReceipt($id: ID!) {
    deleteReceipt(id: $id) {
      id
    }
  }
`);

export const updateReceiptMutation = graphql(`
  mutation UpdateReceipt($id: ID!, $input: UpdateReceiptInput!) {
    updateReceipt(id: $id, input: $input) {
      id
      type
      amount_inc_tax
      amount_tax
      claimable_percentage
      currency
      date
    }
  }
`);

export const reanalyzeReceiptMutation = graphql(`
  mutation ReanalyzeReceipt($id: ID!) {
    reanalyzeReceipt(id: $id) {
      id
      type
      amount_inc_tax
      amount_tax
      claimable_percentage
      currency
      date
      description
    }
  }
`);
